'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = exports.prefix = 'user-permissions/';

var INITIALIZE = exports.INITIALIZE = prefix + 'INITIALIZE';
var DESTORY = exports.DESTORY = prefix + 'DESTORY';
var CREATE_PAGE_PERMISSION = exports.CREATE_PAGE_PERMISSION = prefix + 'CREATE_PAGE_PERMISSION';
var FETCH_USER_PERMISSIONS = exports.FETCH_USER_PERMISSIONS = prefix + 'FETCH_USER_PERMISSIONS';
var UPDATE_USER_PERMISSIONS = exports.UPDATE_USER_PERMISSIONS = prefix + 'UPDATE_USER_PERMISSIONS';
var START_USER_PERMISSIONS_TIMER = exports.START_USER_PERMISSIONS_TIMER = prefix + 'START_USER_PERMISSIONS_TIMER';
var STOP_USER_PERMISSIONS_TIMER = exports.STOP_USER_PERMISSIONS_TIMER = prefix + 'STOP_USER_PERMISSIONS_TIMER';

exports.default = {
  INITIALIZE: INITIALIZE,
  DESTORY: DESTORY,
  CREATE_PAGE_PERMISSION: CREATE_PAGE_PERMISSION,
  FETCH_USER_PERMISSIONS: FETCH_USER_PERMISSIONS,
  UPDATE_USER_PERMISSIONS: UPDATE_USER_PERMISSIONS,
  START_USER_PERMISSIONS_TIMER: START_USER_PERMISSIONS_TIMER,
  STOP_USER_PERMISSIONS_TIMER: STOP_USER_PERMISSIONS_TIMER
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/actions/index.js
 ** module id = 279
 ** module chunks = 0
 **/